import React, { useState } from "react";
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    Collapse,
    Divider,
    Drawer,
    IconButton,
    useTheme,
    useMediaQuery,
} from "@mui/material";

import {
    MdDashboard,
    MdPeople,
    MdSettings,
    MdExpandMore,
    MdExpandLess,
    MdCalendarToday,
    MdAssessment,
    MdTaskAlt,
    MdChat,
    MdMenu,
    MdList,
} from "react-icons/md";

import { Link, useLocation, useNavigate } from "react-router-dom";

import Logo from "../../../assets/logo-cultura.png";

const SIDEBAR_WIDTH = 260;

function SidebarContent({ onNavigate }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [openLeads, setOpenLeads] = useState(true);
    const isActive = (path) => location.pathname === path;

    function handleLogout() {
        localStorage.removeItem("cise:user"); // logout simples
        navigate("/login", { replace: true });
    }

    return (
        <Box
            sx={{
                width: SIDEBAR_WIDTH,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                p: 2,
            }}
        >
            {/* TOPO */}
            <Box sx={{ flex: 1 }}>
                {/* LOGO */}
                <Box sx={{ mb: 3, px: 1 }}>
                    <img src={Logo} alt="CISE" style={{ width: 150 }} />
                </Box>

                {/* GERAL */}
                <Typography sx={{ fontSize: 12, fontWeight: 700, opacity: 0.6, mb: 1, ml: 1 }}>
                    GERAL
                </Typography>

                <List sx={{ p: 0 }}>
                    <ListItemButton
                        component={Link}
                        to="/admin"
                        onClick={onNavigate}
                        sx={{
                            borderRadius: 2,
                            mb: 0.5,
                            py: 1.2,
                            background: isActive("/admin") ? "rgba(33,49,89,0.12)" : "",
                            color: isActive("/admin") ? "var(--cise-blue)" : "#555",
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 38, color: "inherit" }}>
                            <MdDashboard size={20} />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItemButton>
                </List>

                <Divider sx={{ my: 2 }} />

                {/* SDR */}
                <Typography sx={{ fontSize: 12, fontWeight: 700, opacity: 0.6, mb: 1, ml: 1 }}>
                    SDR
                </Typography>

                <List sx={{ p: 0 }}>
                    {/* LEADS */}
                    <ListItemButton
                        onClick={() => setOpenLeads(!openLeads)}
                        sx={{ borderRadius: 2, mb: 0.5, py: 1.2 }}
                    >
                        <ListItemIcon sx={{ minWidth: 38, color: "#777" }}>
                            <MdPeople size={20} />
                        </ListItemIcon>
                        <ListItemText primary="Leads" />
                        {openLeads ? <MdExpandLess /> : <MdExpandMore />}
                    </ListItemButton>

                    <Collapse in={openLeads} timeout="auto" unmountOnExit>
                        <List sx={{ pl: 4 }}>
                            <ListItemButton
                                component={Link}
                                to="/admin/leads"
                                onClick={onNavigate}
                                sx={{
                                    borderRadius: 2,
                                    mb: 0.5,
                                    background: isActive("/admin/leads")
                                        ? "rgba(33,49,89,0.12)"
                                        : "",
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 34 }}>
                                    <MdList size={18} />
                                </ListItemIcon>
                                <ListItemText primary="Todos os Leads" />
                            </ListItemButton>

                            <ListItemButton
                                component={Link}
                                to="/admin/conversas"
                                onClick={onNavigate}
                                sx={{
                                    borderRadius: 2,
                                    background: isActive("/admin/conversas")
                                        ? "rgba(33,49,89,0.12)"
                                        : "",
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 34 }}>
                                    <MdChat size={18} />
                                </ListItemIcon>
                                <ListItemText primary="Conversas" />
                            </ListItemButton>
                        </List>
                    </Collapse>

                    <ListItemButton
                        component={Link}
                        to="/admin/agenda"
                        onClick={onNavigate}
                        sx={{
                            borderRadius: 2,
                            mb: 0.5,
                            py: 1.2,
                            background: isActive("/admin/agenda") ? "rgba(33,49,89,0.12)" : "",
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 38 }}>
                            <MdCalendarToday size={18} />
                        </ListItemIcon>
                        <ListItemText primary="Agenda" />
                    </ListItemButton>

                    <ListItemButton
                        component={Link}
                        to="/admin/tarefas"
                        onClick={onNavigate}
                        sx={{
                            borderRadius: 2,
                            mb: 0.5,
                            py: 1.2,
                            background: isActive("/admin/tarefas") ? "rgba(33,49,89,0.12)" : "",
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 38 }}>
                            <MdTaskAlt size={18} />
                        </ListItemIcon>
                        <ListItemText primary="Tarefas" />
                    </ListItemButton>

                    <ListItemButton
                        component={Link}
                        to="/admin/relatorios"
                        onClick={onNavigate}
                        sx={{
                            borderRadius: 2,
                            mb: 0.5,
                            py: 1.2,
                            background: isActive("/admin/relatorios") ? "rgba(33,49,89,0.12)" : "",
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 38 }}>
                            <MdAssessment size={18} />
                        </ListItemIcon>
                        <ListItemText primary="Relatórios" />
                    </ListItemButton>

                    <ListItemButton
                        component={Link}
                        to="/admin/configuracoes"
                        onClick={onNavigate}
                        sx={{
                            borderRadius: 2,
                            py: 1.2,
                            background: isActive("/admin/configuracoes")
                                ? "rgba(33,49,89,0.12)"
                                : "",
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 38 }}>
                            <MdSettings size={18} />
                        </ListItemIcon>
                        <ListItemText primary="Configurações" />
                    </ListItemButton>
                </List>
            </Box>

            {/* BOTÃO SAIR (BOTTOM) */}
            <Box sx={{ mt: "auto", pt: 2 }}>
                <Divider sx={{ mb: 1 }} />
                <ListItemButton
                    onClick={handleLogout}
                    sx={{
                        borderRadius: 2,
                        py: 1.2,
                        color: "var(--cise-red)",
                        "&:hover": {
                            background: "rgba(201,25,31,0.08)",
                        },
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 38, color: "inherit" }}>
                        <MdMenu size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Sair" />
                </ListItemButton>
            </Box>
        </Box>
    );
}

export default function AdminSidebar({ mobileOpen, onClose }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [open, setOpen] = useState(false);

    const sidebar = (
        <SidebarContent onNavigate={() => isMobile && setOpen(false)} />
    );

    if (isMobile) {
        return (
            <Drawer
                open={mobileOpen}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        width: SIDEBAR_WIDTH,
                    },
                }}
            >
                <SidebarContent onNavigate={onClose} />
            </Drawer>
        );
    }

    // desktop
    return (
        <Box
            sx={{
                width: SIDEBAR_WIDTH,
                height: "100vh",
                borderRight: "1px solid var(--border)",
                background: "#fff",
                position: "fixed",
            }}
        >
            {sidebar}
        </Box>
    );
}
